jQuery( document ).ready(function($) {
    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu-toggle').toggleClass('open');
        $('#header .menu').toggleClass('open');
    })
});